module.exports = __webpack_public_path__ + "img/511.48454b8b.jpg";